import React, { Component } from 'react';
import '../css/projects-card.css';
import ProjectReadMoreButton from './ProjectReadMoreButton';
import ProjectReadMoreModal from './ProjectReadMoreModal';
import ProjectImageZoomModal from './ProjectImageZoomModal';

class ProjectsCard extends Component {
    state = {
        isModalOpen: false,
        isImageZoomed: false
    }

    toggleModal = () => {
        this.setState(prevState => ({
            isModalOpen: !prevState.isModalOpen
        }));
    }

    toggleImageZoom = () => {
        this.setState(prevState => ({
            isImageZoomed: !prevState.isImageZoomed
        }));
    }

    render() { 
        const { imageURL, projectTitle, projectDescription, imagePosition = 'right', projectTag, projectMoreInfo } = this.props;
        
        return (
            <div className='projectsCard-wrapper'>
                <div className='projectsCard'>
                    {imagePosition === 'left' ? (
                        <>
                            <div className="projectImageContainer">
                                <img src={imageURL} alt='projectImage' onClick={this.toggleImageZoom}/>
                            </div>
                            <div className='projectInfos'>
                                <span className='projectTag'>{projectTag}</span>
                                <h1 className='projectTitle'>{projectTitle}</h1>
                                <p className='projectDescription'>{projectDescription}</p>
                                <ProjectReadMoreButton onClick={this.toggleModal}/>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className='projectInfos'>
                                <span className='projectTag'>{projectTag}</span>
                                <h1 className='projectTitle'>{projectTitle}</h1>
                                <p className='projectDescription'>{projectDescription}</p>
                                <ProjectReadMoreButton onClick={this.toggleModal}/>
                            </div>
                            <div className="projectImageContainer">
                                <img src={imageURL} alt='projectImage' onClick={this.toggleImageZoom}/>
                            </div>
                        </>
                    )}
                </div>
                
                <ProjectReadMoreModal 
                    isOpen={this.state.isModalOpen}
                    onClose={this.toggleModal}
                    title={projectTitle}
                    description={projectMoreInfo}
                />

                <ProjectImageZoomModal isActive={this.state.isImageZoomed} imageUrl={imageURL} onClose={this.toggleImageZoom} />
            </div>
        );
    }
}
 
export default ProjectsCard;